import { useState, useContext } from 'react';
import { Row, Col, Accordion, Image } from 'react-bootstrap';
import { CountryContext } from 'CountryContext';
import { Fade } from 'components/Fade';
import { IMAGES } from 'common/images';
import { FAQs } from 'components/FAQ/constants';
import 'components/FAQ/index.scss';

export const FAQ = () => {
  const [active, setActive] = useState(null);
  const { country } = useContext(CountryContext);

  const onSelect = (event) => {
    if (event === active) {
      setActive(null);
      return;
    }

    setActive(event);
  };

  return (
    <Row className="faq">
      <Col>
        <Fade bottom>
          <p className="faq__title">Frequently asked Questions</p>
          <Accordion activeKey={active} onSelect={onSelect}>
            {FAQs[country].map((faq) => (
              <div key={faq.eventKey} className="faq__accordion">
                <Accordion.Toggle as="div" eventKey={faq.eventKey} className="toggle-row">
                  <p className="faq__question">{faq.question}</p>
                  <Image
                    alt="plus-icon"
                    src={IMAGES.Plus}
                    className={`plus ${active === faq.eventKey ? 'rotate' : ''}`}
                  />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={faq.eventKey} className="faq__answer">
                  <pre className="faq__answer">{faq.answer}</pre>
                </Accordion.Collapse>
              </div>
            ))}
          </Accordion>
        </Fade>
      </Col>
    </Row>
  );
};
